import { render } from "./BottomSection.vue?vue&type=template&id=693e53e6&scoped=true&ts=true"
import script from "./BottomSection.vue?vue&type=script&lang=ts"
export * from "./BottomSection.vue?vue&type=script&lang=ts"

import "./BottomSection.vue?vue&type=style&index=0&id=693e53e6&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693e53e6"]])

export default __exports__